<mat-nav-list class="flex flex-row tenant-menu mat-body-2 items-center fs-16">
    <mat-list-item *ngFor="let menu of menuItems" class="menu-item" (click)="menuItemClicked(menu)" [ngClass]="{'fw-700 selected': menu.nameKey === sidenavService.tenantSelectedMenu}">
        {{menu.nameKey | transloco}}
    </mat-list-item>
</mat-nav-list>
